<template>
  <!-- Feature Section start -->
  <section id="feature" class="feature">
    <div class="feature-decor">
      <div class="feature-circle1"><img :src='"../assets/images/feature2.png"' alt=""></div>
    </div>
    <div class="container" style="max-width: 95%;">
      <div class="row">
        <div class="feature-phone">
          <img :src='"../assets/images/Monitor.png"' class="img-fluid" alt="">
        </div>
        <div class="offset-lg-4 col-lg-8">
          <div class="row">
            <div class="col-sm-12 mrgn-md-top mb-3">
              <h2 class="title"><span>Prodo</span> Gestão </h2>
            </div>
            <ul class="feature-style row m-2">
              <li class="col-12 col-md-6" v-for="(item, index) in features" :key="index">
                <div class="feature-icon">
                  <img :src='item.img' alt="icon">
                </div>
                <div class="feature-subtitle">
                  <h3>{{ item.title }}</h3>
                </div>
                <div>
                  <p v-html="item.desc"></p>
                </div>
              </li>
            </ul>
            <router-link :to="{ name: 'Ver_mais' }" class="btn btn-custom theme-color theme-color">
              Saiba mais sobre o Prodo Gestão
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- Feature Section End -->
</template>
<script>
export default {
  name: 'feature',
  data() {
    return {
      features: [
        {
          title: 'CADASTRO DE PESSOAS',
          img: require("../assets/img/Icones-Entrada-2020-72.png"),
          desc: `Com este módulo será muito simples manter o cadastro de clientes e fornecedores da sua empresa sempre atualizados.<br>
                 O sistema trabalha com um buscador automático de dados, com o preenchimento completo do cadastro quando localizado.`
        },
        {
          title: 'CONTAS A RECEBER',
          img: require("../assets/img/Receber-2020-72.png"),
          desc: `Você poderá controlar em tempo real suas cobranças, imprimir boletos de cobrança ou enviá-los por e-mail.<br>
                 Além de gerar inúmeros relatórios que irão facilitar o controle da empresa.`
        },
        {
          title: 'CONTAS A PAGAR',
          img: require("../assets/img/Pagar-2020-72.png"),
          desc: `Sua empresa vai poder manter um histórico das contas a pagar a vencer, vencidas, quitadas e atrasadas.<br>
                 Além de gerar inúmeros relatórios que irão facilitar o controle da empresa.`
        },
        {
          title: 'CONTROLE DE ESTOQUE',
          img: require("../assets/img/Estoque-2020-72.png"),
          desc: `Será fácil organizar, controlar e classificar os produtos do seu estoque.<br>
                 Poderá trabalhar com grades, números de série e foto nos produtos.<br>
                 Pode configurar preço de atacado e varejo`
        },
        {
          title: 'LIVRO CAIXA',
          img: require("../assets/img/Caixa-2020-72.png"),
          desc: `Módulo funciona integrado ao restante do sistema desta forma as informações são preenchidas de forma praticamente automática.<br>
                 Acompanhe todo histórico financeiro de entradas e saídas de valores da empresa tudo estará alimentado neste módulo.`
        },
        {
          title: 'PDV',
          img: require("../assets/img/PDV-2020-72.png"),
          desc: `É muito fácil de utilizar nosso PDV, podendo emitir NFC-e, SAT (SP) e MFE (CE)
                          Pedido de Venda<br>
                          Abertura e fechamento sem limite diário<br>
                          Recebimento de contas integrado<br>
                          Emissão de Orçamentos<br>
                          Integração com TEF<br>
                          Integração com balança e gaveta`
        }
      ],
    }
  }
}
</script>
<style scoped>
p {
  font-size: 11px !important;
}

.feature-style li {
  margin-bottom: 20px !important;
}

.feature-subtitle h3 {
  padding-left: 60px;
  margin-top: 25px;
  margin-bottom: 20px;
}

.feature-icon {
  position: absolute;
  padding: 0;
  left: 5px;
}

.row h3 {
  color: #18e7d3;
}

a h3 {
  margin-top: 0;
  padding: 1rem;
  padding-top: 0;
}

a h3:hover {
  color: #137d8b;
}

@media (max-width: 1366px) {
  .feature-phone img {
    height: 420px;
    margin-top: 4rem;
    margin-left: -2rem;
    width: 100%;
  }
}

@media (min-width: 1367px) and (max-width: 4669px) {
  .feature-phone img {
    height: 420px;
    margin-top: 7rem;
    margin-left: -6rem;
    width: 100%;
  }
}

.feature-decor .feature-circle1 {
  right: -14px;
  bottom: 198px;
}
</style>



// WEBPACK FOOTER //
// src/components/feature.vue